import React from "react";
import { createUseStyles } from "react-jss";
import MenuBar from "../components/MenuBar";
import Page from "../components/Page";
import { useGetAbout } from "../hooks/useGetAbout";
import { themeColors } from "../theme";
import { PageRoutes } from "../utils/routes";
import ReactMarkdown from "react-markdown";

const useStyles = createUseStyles({
  title: {
    fontSize: 32,
    fontWeight: "600",
    alignSelf: "flex-start",
    flexGrow: 1,
    lineHeight: 2,
    color: themeColors.blue,
    "@media only screen and (max-width: 700px)": {
      marginTop: 40,
    },
  },
  aboutContainer: {
    maxWidth: 1280,
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    "@media only screen and (max-width: 700px)": {
      padding: 24,
    },
  },
  paragraph: {
    color: themeColors.blue,
    fontSize: 18,
    lineHeight: "26px",
    whiteSpace: "preWrap",
  },
});

const englishAboutText = `The Change direction! IKE Festival is a summer gathering of Hungarian Christian youth from Transylvania, organized in a festival format. It was first held in 2011 by YMCA Transylvania. Taking place every two years, the festival offers programs that strengthen spiritual, intellectual, and physical life: worship sessions, devotions, lectures, discussions, workshops, and sports activities. More than a thousand young people gather at the event to experience the blessings of encountering God in community.

This year’s motto is: **You can live forever.** The theme of the festival is framed by the ideas of “**now**” and “**forever**.” It connects the understanding that not only what I see and have now matters, but also what lies ahead, what goes beyond the temporary. At the same time, this is true in reverse: we should not postpone life to a time when we will be with God, but live fully already **now** what has been given to us. A human life is lived between these two realities. Everything we have now is a gift from God, just as what has been prepared for us in eternity. **We can live forever, because God loves us this much!**`;

const About = () => {
  const { about } = useGetAbout();
  const classes = useStyles();
  return (
    <>
      <Page>
        <MenuBar selectedKey={PageRoutes.About} />
        <div className={classes.aboutContainer}>
          <span className={classes.title}>A fesztiválról</span>
          <ReactMarkdown className={classes.paragraph}>
            {about?.other ?? ""}
          </ReactMarkdown>
          <span className={classes.title}>About the Festival</span>
          <ReactMarkdown className={classes.paragraph}>{englishAboutText}</ReactMarkdown>
        </div>
      </Page>
    </>
  );
};

export default About;
